import { render } from "./ExtendedValueTypes.vue?vue&type=template&id=1b95ed28"
import script from "./ExtendedValueTypes.vue?vue&type=script&lang=ts"
export * from "./ExtendedValueTypes.vue?vue&type=script&lang=ts"
script.render = render

export default script